import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { addUserOnline, removeUserOnline } from '../thunks/users/userOnlineList';
import { usePusher } from '../providers/PusherProvider';

const PusherOnlineListener = () => {
  const dispatch = useDispatch();
  const { pusher: pusherClient, pusherReady } = usePusher();
  useEffect(() => {
    if (!pusherReady || !pusherClient) return;
    const channelOnline = pusherClient?.subscribe('presence-users-online');

    channelOnline?.bind('pusher:member_removed', (data) => {
      dispatch(removeUserOnline(data));
    });

    channelOnline?.bind('pusher:member_added', (data) => {
      dispatch(addUserOnline(data));
    });

    channelOnline?.bind('pusher:subscription_succeeded', () => {
      channelOnline?.members?.each((member) => dispatch(addUserOnline(member)));
    });
  }, [pusherClient, pusherReady]);

  return null;
};

export default PusherOnlineListener;
